// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"6495": "a9b28c737317","7141": "cdec85e31733","7310": "e361d93e4040","8357": "dd422574e14d",}[chunkId] + ".css"
}